export default __webpack_public_path__ + "static/media/Sumeet Jadhav.d7d6582e.jpeg";